<template>
	<div :class="['hidden sm:flex absolute top-0 inset-x-0 justify-center overflow-hidden pointer-events-none', props.class]">
		<div class="w-[108rem] overflow-clip flex-none flex justify-end">
			<picture>
				<img
					:src="brand.cardHeaderBg"
					alt=""
					class="w-[71.75rem] flex-none max-w-none dark:hidden scale-x-[-1]"
					decoding="async">
			</picture>
		</div>
	</div>
</template>

<script lang="ts">
	export default { name: 'CardHeaderBackdrop' } // name the component
</script>

<script setup lang="ts">
	import {
		defineProps
	} from 'vue'

	import {
		useBrand
	} from '@/utilities/brand'

	const props = defineProps({
		class: {
			type: String,
			default: "opacity-30"
		}
	})

	const brand = useBrand()
</script>
